module.exports = __webpack_public_path__ + "img/MA-flag.7f1b5dd7.svg";